import React, { useState } from 'react';
import { getI18n } from 'react-i18next';

import { Button, Cascader, Tooltip } from 'antd';
import { EllipsisOutlined, EyeOutlined } from '@ant-design/icons';
import { FiEdit } from 'react-icons/fi';

import { withRouter } from 'react-router';
import { pathTo } from '../../../Routes';
import ConfirmationModal from '../../../elements/components/ConfirmationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

const confirmTexts = {
  title: getI18n().t('learning_admin_module_action_delete_title'),
  description: null,
  leaveText: getI18n().t('learning_admin_module_action_delete_leave'),
  saveText: getI18n().t('learning_admin_module_action_delete_save'),
};

const LearningAdminModulesListAction = ({
  row,
  partnershipId,
  editScreen,
  history,
  handleDelete,
  showDetail,
  ...props
}) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const { id, public_status } = row;

  const menuItems = [
    {
      label: (
        <span className='module-table-menu-item'>
          <FiEdit className='module-action-icon-edit' />
          <span className='text-align'>
            {getI18n().t('learning_admin_module_action_edit')}
          </span>
        </span>
      ),
      value: 1,
    },
    {
      label:
        public_status !== 3 ? (
          <Tooltip
            placement='left'
            title={getI18n().t('learning_modules_message_info_delete')}
            arrowPointAtCenter={true}
          >
            <span className='module-table-menu-item' style={{ color: 'gray' }}>
              <FontAwesomeIcon icon={faTrashCan} size='2x' />
              <span className='text-align'>
                {getI18n().t('learning_admin_module_action_delete')}
              </span>
            </span>
          </Tooltip>
        ) : (
          <span className='module-table-menu-item' style={{ color: '#F44336' }}>
            <FontAwesomeIcon icon={faTrashCan} size='2x' />
            <span className='text-align'>
              {getI18n().t('learning_admin_module_action_delete')}
            </span>
          </span>
        ),
      value: 2,
      disabled: public_status !== 3,
    },
    {
      label: (
        <span className='module-table-menu-item'>
          <EyeOutlined className='module-action-icon-preview' />
          <span className='text-align'>
            {getI18n().t('learning_admin_module_action_preview')}
          </span>
        </span>
      ),
      value: 3,
    },
  ];

  const onChange = (item) => {
    const value = item[0];

    if (value === 1) {
      history.push(
        pathTo(editScreen, { partnership_id: partnershipId, id: id })
      );
    } else if (value === 2) {
      setConfirmationModalOpen(true);
    } else if (value === 3) {
      showDetail(id);
    }
  };

  const handleConfirmLeave = () => {
    setConfirmationModalOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmationModalOpen(false);
    handleDelete();
  };

  return (
    <span onClick={(e) => e.stopPropagation()} className='actions'>
      <Cascader
        options={menuItems}
        onChange={onChange}
        dropdownMenuColumnStyle={{ height: '32px' }}
        defaultValue={[]}
        value={[]}
      >
        <Button
          style={{ verticalAlign: '2px' }}
          icon={<EllipsisOutlined />}
          type='text'
          onClick={(e) => e.stopPropagation()}
        ></Button>
      </Cascader>
      <ConfirmationModal
        texts={confirmTexts}
        openConfirmationModal={confirmationModalOpen}
        onLeaveConfirmation={handleConfirmDelete}
        onSaveConfirmation={handleConfirmLeave}
        onCancel={handleConfirmLeave}
        setConfirmationModalOpen={setConfirmationModalOpen}
      />
    </span>
  );
};

export default withRouter(LearningAdminModulesListAction);
